import React from 'react';
import ReactGA from 'react-ga';
import paintbrushLanding from '../../assets/images/paintbrush_landing.svg';
import Hero from '../../components/heroV2/hero';
import FeaturedProjectShowcase from '../../components/featuredProjectShowcase/featuredProjectShowcase';
import style from './homeV2.module.scss';


export default function Home() {
  const [isMobile, setIsMobile] = React.useState(false);
  ReactGA.pageview(window.location.pathname + window.location.search);

  const checkIsMobile = () => {
    if(window.innerWidth < 920){
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }

  React.useEffect(() => {
    checkIsMobile();
    window.scrollTo({ top: 0 });
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  return (
    <main className={style.homeContainer}>
      <div className={style.heroStack}>
        <Hero isMobile={isMobile} />
      </div>
      <div className={style.paintbrushBand} aria-hidden>
        <img src={paintbrushLanding} alt="" className={style.paintbrushImg} />
      </div>
      <FeaturedProjectShowcase />
    </main>
  )
}
